// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__NRl7v","backdrop":"Modal_backdrop__YagfI","modal__container":"Modal_modal__container__HqwCk"};